import type { ItemPermission } from '@/lib/api/types/items';

export function isItemEditable(
  permission: ItemPermission | undefined,
  externalKey: string | null | undefined,
  integrationItemsEditable: boolean,
): boolean {
  if (permission !== 'EDIT') return false;
  if (externalKey && !integrationItemsEditable) return false;
  return true;
}
